import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect, populate, isLoaded } from 'react-redux-firebase';

import { ProjectList } from '../../components/Project';
import ProjectPreviewContainer from './ProjectPreviewContainer';
import { selectProject, toggleBatchEdit, deselectAll } from '../../redux/actions/projects';
import { objToArr } from '../../helpers';
import BasicLayout from '../BasicLayout';
import NewProjectButton from '../../components/NewProjectButton';
import ProjectEditContainer from './ProjectEditContainer';
import { getFileDownloadUrl } from '../../helpers/fileHelpers';

// import Styles from './ProjectIndexContainer.styles';

const child = {
  flex: '0 0 50%',
  display: 'flex',
};

class ProjectIndexContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.projectId) {
      this.props.selectProject(this.props.match.params.projectId);
      this.setState({
        isModalOpen: true,
      });
    }
  }

  openModal() {
    this.setState({
      isModalOpen: true,
    });
  }

  handleSubmit() {
    // this.props.onSubmit(event);
    this.handleClose();
  }

  handleClose() {
    this.setState({
      isModalOpen: false,
    });
  }
  render() {
    const { match, projects } = this.props;
    const projectCount = projects ? projects.length : '0';

    const selectedProject =
      this.props.selectedProject && this.props.selectedProject.length > 0
        ? projects.filter(project => project.id === this.props.selectedProject)[0]
        : projects.filter(project => project.id === match.params.projectId)[0];

    if (!isLoaded(projects)) {
      return null;
    }

    return (
      <BasicLayout
        match={match}
        searchEnabled={false}
        toolbar={
          <div
            style={{
              display: 'flex',
              flex: 1,
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <NewProjectButton />
            <div style={{ flexGrow: 2, textAlign: 'center' }}>{`Projects (${projectCount})`}</div>
            <div style={{ display: 'flex', flex: '1 0 0%' }} />
          </div>
        }
      >
        <div style={{ display: 'flex', flex: 1 }}>
          <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
            <ProjectList {...this.props} style={child} onEdit={this.openModal} />
            <ProjectPreviewContainer {...this.props} style={child} />
          </div>
          {selectedProject && (
            <ProjectEditContainer
              isOpen={this.state.isModalOpen}
              handleClose={this.handleClose}
              handleSubmit={this.handleSubmit}
              history={this.props.history}
              selected={selectedProject}
            />
          )}
        </div>
      </BasicLayout>
    );
  }
}

ProjectIndexContainer.defaultProps = {
  projects: [],
  selectedProject: {},
};

ProjectIndexContainer.propTypes = {
  projects: PropTypes.arrayOf(Object),
  match: PropTypes.shape({
    isExact: PropTypes.bool.isRequired,
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    params: PropTypes.shape({
      projectId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape().isRequired,
  selectProject: PropTypes.func.isRequired,
  selectedProject: PropTypes.arrayOf(Object),
};

const mapDispatchToProps = dispatch => ({
  selectProject: (projectId) => {
    dispatch(selectProject(projectId));
  },
  toggleBatchEdit: () => {
    dispatch(toggleBatchEdit());
  },
  deselectAll: () => {
    dispatch(deselectAll());
  },
});

const populates = [
  { child: 'createdBy', root: 'users', keyProp: 'key' },
  { child: 'members', root: 'users', keyProp: 'key' },
  { child: 'owners', root: 'users', keyProp: 'key' },
];

const mapStateToProps = (state, props) => {
  const { firebase, projects, router } = state;
  return {
    selected: projects.selectedProjects,
    selectedProject: projects.selectedProjects ? projects.selectedProjects[0] : null,
    batchEdit: projects.batchEdit,
    isRequesting: firebase.requesting.projects,
    location: router.location,
    firebase: props.firebase,
    projects: objToArr(populate(firebase, 'projects', populates)),
  };
};

export default compose(
  connect(({ firebase, organizations, projects }) => ({
    auth: firebase.auth,
    currentOrganizationId: organizations.currentOrganizationId,
    selectedProjects: projects.selectedProjects,
  })),
  firebaseConnect((props) => {
    const listeners = [
      {
        path: '/organizations',
        queryParams: [`orderByChild=members/${props.auth.uid}`, 'equalTo=true'],
      },
      {
        path: '/projects',
        populates,
        queryParams: [`orderByChild=organizations/${props.currentOrganizationId}`, 'equalTo=true'],
      },
    ];
    return listeners;
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ProjectIndexContainer);



// WEBPACK FOOTER //
// ./src/containers/Project/ProjectIndexContainer.js